import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GrAdd } from "react-icons/gr";
import { Table, Modal, message } from "antd";
import { getClientInfo } from "../../Utils/client/client";
import DomainCreationPopup from "../../components/Client/DomainCreationPopup";
import { deleteDomain, getDomainInfo } from "../../Utils/domains/domains";
import Loading from "../../components/Shared/Loading";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const ClientDomainInfo = ({ clientId, isAdmin }) => {
  const navigate = useNavigate();
  const param = useParams();
  const [showAddDomain, setShowAddDomain] = useState(false);
  const [showEditDomain, setShowEditDomain] = useState(false);
  const [editingDomain, setEditingDomain] = useState(null);

  const [clientInfo, setClientInfo] = useState(null);
  const [domainInfo, setDomainInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const getClientDetail = async () => {
    setLoading(true);
    try {
      const res = await getClientInfo(clientId || param.clientId);  // Use clientId from props or param
      if (!res.data.user) {
        navigate("/admin/client/all");
        return;
      }
      setClientInfo(res.data);
      setDomainInfo(res.data.domains);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    getClientDetail();
  }, []);

  const handleDelete = (domainId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer ce domaine ?",
      content: "Cette action est irréversible.",
      okText: "Oui",
      okType: "danger",
      cancelText: "Non",
      onOk: async () => {
        try {
          await deleteDomain(domainId);
          message.success("Domaine supprimé avec succès");
          getClientDetail();
        } catch (error) {
          console.error("Erreur lors de la suppression du domaine:", error);
          message.error("Erreur lors de la suppression du domaine");
        }
      },
    });
  };

  const handleEdit = async (domainId) => {
    try {
      const res = await getDomainInfo(domainId);

      setEditingDomain({
        ...res.data,
        domain_manager_name: res.data.domain_manager_first_name + " " + res.data.domain_manager_last_name,
     });
  
      // Show the edit domain modal or component

      setShowEditDomain(true);
    } catch (error) {
      console.error("Erreur lors de la récupération des informations du domaine:", error);
      message.error("Erreur lors de la récupération des informations du domaine");
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "NOM DU DOMAINE",
      dataIndex: "domain_name",
      key: "domain_name",
    },
    {
      title: "NOM COMPLET DU RESPONSABLE",
      dataIndex: "domain_manager_name",
      key: "domain_manager_name",
      render: (text, record) => {
        console.log(record);
        if (record.domain_manager_first_name === "null" || !record.domain_manager_first_name || record.domain_manager_first_name === null) {
          return <div>Non défini</div>;
        }
        return (
          <div>
            {record.domain_manager_first_name +
              " " +
              record.domain_manager_last_name}
          </div>
        );
      },
    },
    {
      title: "NUMÉRO TÉLÉPHONE",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "ADRESSE MAIL",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "NOMBRE D'EXPLOITATIONS",
      dataIndex: "exploitation_number",
      key: "exploitation_number",
      render: (text, record) => {
        const exploitationNumber = clientInfo.exploitations.filter(
          (it) => it.domain_id === record.domain_id
        );
        return <div>{exploitationNumber.length}</div>;
      },
    },
    {
      title: "ACTIONS",
      key: "actions",
      render: (text, record) => (
        <span className="flex justify-around">
          <EditOutlined
            onClick={() => handleEdit(record.domain_id)}
            className="text-blue-500 text-2xl p-1 rounded-lg hover:bg-slate-200 cursor-pointer mr-4"
          />
          <DeleteOutlined
            onClick={() => handleDelete(record.domain_id)}
            className="text-red-500 text-2xl cursor-pointer p-1 rounded-lg hover:bg-slate-200"
          />
        </span>
      ),
    },
  ];


  if (!isAdmin) {
    columns.pop();
  }


  return (
    <>
      {loading && <Loading />}
      {clientInfo && (

        <div>
          <Table
            dataSource={domainInfo}
            columns={columns}
            rowKey={(row) => row.domain_id}
            pagination={false}
          />
        </div>
      )}

      {isAdmin &&
        <div
        className="fixed flex items-center justify-center rounded-full shadow-lg bg-blue-500 w-16 h-16 bottom-10 right-10 text-white text-2xl cursor-pointer hover:bg-blue-600 transition duration-300 ease-in-out"
        onClick={() => setShowAddDomain(true)}
      >
        <GrAdd className="text-4xl" />
      </div>}

      {showAddDomain && (
        <DomainCreationPopup
          visible={showAddDomain}
          onCancel={() => setShowAddDomain(false)}
          clientId={clientInfo?.user?.user_id}
          onSubmit={() => {
            getClientDetail();
            setShowAddDomain(false);
          }}
          isEditing={false}
        />
      )}

      {showEditDomain && (
        <DomainCreationPopup
          visible={showEditDomain}
          onCancel={() => setShowEditDomain(false)}
          clientId={clientInfo?.user?.user_id}
          onSubmit={() => {
            getClientDetail();
            setShowEditDomain(false);
          }
          }
          initialValues={editingDomain}
          isEditing={true}
        />
      )}
    </>
  );
};

export default ClientDomainInfo;